import React from 'react'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../../../../utils/inview'
import { TextWithImageBlock } from '../blocksState'
import { PictureLayout } from '../../../image/imageLayout'

export const TextWithImageBlockLayout = (props: TextWithImageBlock) => {
  const { image, image_position, label, text, title } = props
  return (
    <InView
      as="section"
      threshold={0}
      triggerOnce={true}
      onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
      className={`block block--text-image image--${image_position} spacing--s-bottom`}
    >
      <div className="block__inner container--s gutter--m">
        <div className="block__layout">
          <div className="block__text">
            {(title || label) && (
              <header className="block__header reverse-order">
                {title && <h2 className="block__title title--xs">{title}</h2>}
                {label && (
                  <span className="block__label label--s">{label}</span>
                )}
              </header>
            )}

            {text && (
              <div
                className="block__text text--styled"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
          </div>

          {image && (
            <div className="block__visual fit-object">
              <PictureLayout.Img
                image={{
                  Title: image.alt,
                  Url: image.url,
                }}
                width="200"
                height="200"
                extraClasses="block__image"
                lazyload
              />
            </div>
          )}
        </div>
      </div>
    </InView>
  )
}
